module.exports = __webpack_public_path__ + "static/media/1015323.f807ee11.png";